import { render, staticRenderFns } from "./FoodSideDishesTable.vue?vue&type=template&id=1715555b"
import script from "./FoodSideDishesTable.vue?vue&type=script&lang=js"
export * from "./FoodSideDishesTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports